import type { NormalizedRecordSearch } from '@ltvco/refresh-lib/utils';

const RECALL_TYPE_TO_CHIP: Record<string, string> = {
  vehicle: 'Vehicle',
  food: 'Food',
  drugs: 'Drugs',
  medicalDevices: 'Medical Devices',
  consumerProducts: 'Consumer Products',
};

const QUERY_TYPE_TO_SEARCH_TYPE: Record<string, string> = {
  vin: 'VIN',
  licensePlate: 'LICENSE_PLATE',
  ymm: 'YEAR_MAKE_MODEL',
  name: 'company_or_product',
  number: 'recall_number',
};

export function buildRecallsRedirectUrl(data: NormalizedRecordSearch): string {
  const raw = data.raw as
    | { recallType?: unknown; queryData?: unknown }
    | undefined;
  const recallType = typeof raw?.recallType === 'string' ? raw.recallType : '';
  const queryData =
    raw?.queryData && typeof raw.queryData === 'object'
      ? (raw.queryData as Record<string, string>)
      : undefined;

  const chip = RECALL_TYPE_TO_CHIP[recallType] ?? 'Vehicle';
  let url = `/dashboard/court-cases/recalls?liSection=class-actions-recalls&recallPill=${encodeURIComponent(
    chip
  )}`;

  if (queryData) {
    const qType = queryData.type ?? '';
    const searchType = QUERY_TYPE_TO_SEARCH_TYPE[qType];
    if (searchType) {
      url += `&recallSearchType=${searchType}`;
      if (qType === 'vin' && queryData.vin) {
        url += `&vin=${encodeURIComponent(queryData.vin)}`;
      } else if (qType === 'licensePlate' && queryData.licensePlate) {
        url += `&licensePlate=${encodeURIComponent(queryData.licensePlate)}`;
        if (queryData.state) {
          url += `&state=${encodeURIComponent(queryData.state)}`;
        }
      } else if (
        qType === 'ymm' &&
        queryData.year &&
        queryData.make &&
        queryData.model
      ) {
        url += `&year=${encodeURIComponent(
          queryData.year
        )}&make=${encodeURIComponent(
          queryData.make
        )}&model=${encodeURIComponent(queryData.model)}`;
        if (queryData.trim) {
          url += `&trim=${encodeURIComponent(queryData.trim)}`;
        }
      } else if ((qType === 'name' || qType === 'number') && queryData.value) {
        url += `&recallQuery=${encodeURIComponent(queryData.value)}`;
      }
    }
  }

  return url;
}
